import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PopupData } from '../../../model/popup-data';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-fd-popup',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
  templateUrl: './fd-popup.component.html',
  styleUrl: './fd-popup.component.scss'
})
export class FDPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<FDPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PopupData,
    private router: Router
  ){}

  okayClick(): void {
    this.dialogRef.close(true);
    if(this.data.okayBtnRedirect){
      this.router.navigate([this.data.okayBtnRedirect])
    }
  }

  cancelClick(): void{
    
    this.dialogRef.close(false);
    if(this.data.cancelBtnRedirect){
      this.router.navigate([this.data.cancelBtnRedirect])
    }
  }


}
